import {css} from '@emotion/css';
import {spacing} from '@fo/shared/styles/variables/spacing';

const styles = {
  submitButton: css`
    label: singlePageForm__submitButton;

    text-align: center;
    button {
      margin-bottom: ${spacing.XS};
    }
  `,
};

export default styles;
